import { useContext } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import type { ModulesContextType } from '../../contexts/modules-context/modules-context';
import { ModulesContext } from '../../contexts/modules-context/modules-context';

export const useModulesContext = (): ModulesContextType => {
  const { isSubpage } = usePageContext();
  const context = useContext(ModulesContext);

  if (isSubpage) {
    throw Error('useModulesContext cannot be used in subpages');
  }

  if (!context) {
    throw Error(
      'useModulesContext must be used within a ModulesContextProvider'
    );
  }

  return context;
};
